<template>
  <div id="support-performance" class="pa-7">
    <!--タイトル-->
    <span class="subHead">
      {{ title }}
    </span>
    <!--アイコン-->
    <v-icon class="mb-2" color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--説明-->
    <div class="mt-2">
      {{ description }}
    </div>
    <!--データテーブル-->
    <v-data-table
    :headers="headers"
    :items="data">
    </v-data-table>
    <!--データテーブル下部の注釈-->
    <div>
      {{ asterisk }}
    </div>
    <!--これまで作成したサイトの画像集-->
    <div id="support-site">
    <v-row>
 <!-- <v-col cols="12" xs="6" md="3" lg="3" xl="3"
      v-for="(item, i) in performance"
      :key="i">
        <v-card
        height="100%"
        elevation="3"
        :href="hasLink(i)"
        :disabled="cardDisable(i)">
          <a :to="item.href">
            <v-layout justify-center>
            <v-img
            :src="item.src"
            :width="item.width"
            :height="item.height"
            >
            </v-img>
            </v-layout>
         </a>
          <v-card-title>
            <a
            :href="item.href"
            :v-if="item.hasLink"
            :style="style(i)"
            id="pageTitle">
              {{ item.title }}
            </a>
          </v-card-title>
        </v-card>
      </v-col> -->

<v-col
  cols="12"
  xs="6"
  md="3"
  lg="3"
  xl="3"
  v-for="(item, i) in performance"
  :key="i"
  class="d-flex"
>
  <!-- リンクありの場合 -->
  <a
    v-if="item.hasLink === 'true'"
    :href="item.href"
    target="_blank"
    class="card-link"
  >
    <v-card class="card-fixed hover-card" elevation="3">
      <v-layout justify-center>
        <v-img
          :src="item.src"
          class="card-image"
          cover
        />
      </v-layout>
      <v-card-title>
        <span id="pageTitle" :class="{ 'link-title': item.hasLink === 'true' }">
          {{ item.title }}
        </span>
      </v-card-title>
    </v-card>
  </a>

  <!-- リンクなしの場合 -->
  <div v-else class="card-link">
    <v-card class="card-fixed " elevation="3">
      <v-layout justify-center>
        <v-img
          :src="item.src"
          class="card-image"
          cover
        />
      </v-layout>
      <v-card-title>
        <span class="title-no-link">
          {{ item.title }}
        </span>
      </v-card-title>
    </v-card>
  </div>
</v-col>

    </v-row>
    </div>
  </div>
</template>

<style>
#pageTitle {
  font-size: 17px;
}
/* タイトルのスタイル */
.title-link {
  font-size: 17px;
  color: inherit;
}

.title-no-link {
  font-size: 17px;
  color: black;
}

/* タイトルのスタイル */
.title-link {
  font-size: 17px;
  color: inherit;
}

.title-no-link {
  font-size: 17px;
  color: black;
}

/* カード全体を同じ高さに */
.card-fixed {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* 画像の高さを統一 */
.card-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

/* aタグとdivを見た目揃えるため */
.card-link {
  text-decoration: none;
  width: 100%;
  height: 100%;
  display: block;
}
/* リンクありタイトルは青色に */
.link-title {
  color: #1976d2; /* Vuetifyのblue色 */
}

/* ホバー効果で色が薄くなる */
.hover-card:hover {
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '実績',
      // タイトル横のアイコン
      icon: 'mdi-file-document-outline',
      // 説明
      description: '医歯薬系学会ホームページ制作、運用実績',
      // データテーブル下部の説明
      asterisk: '※HP例です。全て更新保守を行っています。リンクを許可しているものは、HPへリンクします。',
      // データテーブルのヘッダー
      headers: [
        {
          text: '年度',
          value: 'year',
          align: 'left',
          filterable: 'false'
        },
        {
          text: '国際大会/全国大会(件)',
          value: 'whole',
          filterable: 'false'
        },
        {
          text: '地方大会/研究会(件)',
          value: 'country',
          filterable: 'false'
        },
        {
          text: '事前参加登録システムを利用(件)',
          value: 'perticipation',
          filterable: 'false'
        },
        {
          text: '演題登録システムを利用(件)',
          value: 'abstract',
          filterable: 'false'
        }
      ],
      // データテーブルの内容部分
      data: [
        {
          year: '2024',
          whole: '3',
          country: '',
          perticipation: '1',
          abstract: '1'
        },
        {
          year: '2023',
          whole: '2',
          country: '1',
          perticipation: '2',
          abstract: '1'
        },
        {
          year: '2022',
          whole: '2',
          country: '1',
          perticipation: '2',
          abstract: '1'
        },
        {
          year: '2021',
          whole: '1',
          country: '1',
          perticipation: '1',
          abstract: '1'
        },
        {
          year: '2020',
          whole: '',
          country: '2',
          perticipation: '1',
          abstract: '1'
        },
        {
          year: '2019',
          whole: '1',
          country: '2',
          perticipation: '2',
          abstract: '1'
        },
        {
          year: '2018',
          whole: '3',
          country: '1',
          perticipation: '1',
          abstract: ''
        },
        {
          year: '2017',
          whole: '5',
          country: '1',
          perticipation: '1',
          abstract: '1'
        },
        {
          year: '2016',
          whole: '4',
          country: '2',
          perticipation: '1',
          abstract: '1'
        },
        {
          year: '2015',
          whole: '3',
          country: '1',
          perticipation: '',
          abstract: ''
        },
        {
          year: '2014',
          whole: '3',
          country: '2',
          perticipation: '2',
          abstract: '1'
        },
        {
          year: '2013',
          whole: '1',
          country: '',
          perticipation: '',
          abstract: ''
        },
        {
          year: '2012',
          whole: '',
          country: '1',
          perticipation: '1',
          abstract: '1'
        }
      ],
      // 作成したホームページの画像集
      performance: [
        // 第32回日本Cell Death学会学術集会
        {
          src: require('../../assets/supportConference/32celldeath.png'),
          width: '250',
          height: '290',
          hasLink: 'true',
          href: 'https://square.umin.ac.jp/celldeath32/',
          title: '第32回日本Cell Death学会学術集会 様'
        },
        // 第15回日本医療マネジメント学会大阪支部学術集会
        {
          src: require('../../assets/supportConference/jhmobm15.png'),
          width: '250',
          height: '290',
          hasLink: 'true',
          href: 'https://square.umin.ac.jp/jhmobm15/',
          title: '第15回日本医療マネジメント学会大阪支部学術集会 様'
        },
        // 第14回日本医療マネジメント学会大阪支部学術集会
        {
          src: require('../../assets/supportConference/14_nihoniryou.png'),
          width: '250',
          height: '290',
          hasLink: 'false',
          href: 'https://square.umin.ac.jp/jhmobm14/',
          title: '第14回日本医療マネジメント学会大阪支部学術集会 様'
        },
        // 日本脂質栄養学会第３０回大会
        {
          src: require('../../assets/supportConference/30_nihonshishitsu.png'),
          width: '250',
          height: '290',
          hasLink: 'true',
          href: 'http://square.umin.ac.jp/jsln30/',
          title: '日本脂質栄養学会第３０回大会 様'
        },
        // 第4回国際ケアリング学会
        {
          src: require('../../assets/supportConference/4_iscpc.png'),
          width: '250',
          height: '290',
          hasLink: 'true',
          href: 'https://square.umin.ac.jp/iscpc4/index.html',
          title: '第4回国際ケアリング学会 様'
        },
        // 第13回日本医療マネジメント学会大阪支部学術集会
        {
          src: require('../../assets/supportConference/13_nihoniryou.png'),
          width: '250',
          height: '290',
          hasLink: 'true',
          href: 'https://square.umin.ac.jp/jhmobm13/',
          title: '第13回日本医療マネジメント学会大阪支部学術集会 様'
        },
        // 第31回日本助産師学会学術集会
        {
          src: require('../../assets/supportConference/jam2017.jpg'),
          width: '250',
          height: '290',
          hasLink: 'false',
          href: 'http://jam2017.umin.jp/',
          title: '第31回日本助産学会学術集会 様'
        },
        // 第30回日本母乳哺育学会・学術集会
        {
          src: require('../../assets/supportConference/bonyu30.jpg'),
          width: '250',
          height: '290',
          hasLink: 'false',
          title: '第30回日本母乳哺育学会・学術集会 様'
        },
        // 第30回日本毒性病理学会総会及び学術集会
        {
          src: require('../../assets/supportConference/dokusei.jpg'),
          width: '230',
          height: '330',
          hasLink: 'false',
          title: '第30回日本毒性病理学会総会 様'
        },
        // 第13回日本糖尿病情報学会年次学術集会
        {
          src: require('../../assets/supportConference/tounyo.jpg'),
          width: '229',
          height: '330',
          hasLink: 'false',
          title: '第13回日本糖尿病情報学会年次学術集会 様'
        },
        // 第121回日本薬理学会近畿部会
        {
          src: require('../../assets/supportConference/yakuri.jpg'),
          width: '225',
          height: '210',
          hasLink: 'false',
          title: '第121回日本薬理学会近畿部会 様'
        },
        // 第23回腎とフリーラジカル研究会
        {
          src: require('../../assets/supportConference/freeradi.jpg'),
          width: '225',
          height: '210',
          hasLink: 'false',
          title: '第23回腎とフリーラジカル研究会 様'
        },
        // 第37回日本重症心身障害学会学術集会
        {
          src: require('../../assets/supportConference/shinshin.jpg'),
          width: '225',
          height: '200',
          hasLink: 'false',
          title: '第37回日本重症心身障害学会学術集会 様'
        },
        // 第50回日本先天異常学会学術集会
        {
          src: require('../../assets/supportConference/senten.jpg'),
          width: '225',
          height: '210',
          hasLink: 'false',
          title: '第50回日本先天異常学会学術集会 様'
        },
        // 第48回日本薬学会・日本薬剤師会・日本病院薬剤師会 中国四国支部学術大会
        {
          src: require('../../assets/supportConference/chushikoku.jpg'),
          width: '225',
          height: '180',
          hasLink: 'false',
          title: '第48回日本薬学会・日本薬剤師会・日本病院薬剤師会 中国四国支部学術大会 様'
        }
      ]
    }
  },
  // methods: {
  //   // リンク先がない場合はaタグを無効に
  //   hasLink: function (index) {
  //     if (!(index === 0 || index === 12)) {
  //       return false
  //     } else {
  //       return this.performance[index].href
  //     }
  //   },
  //   cardDisable: function (index) {
  //     if (!(index === 0 || index === 12)) {
  //       return true
  //     } else {
  //       return false
  //     }
  //   },
  //   // リンク先がない場合はテキストカラーを黒に
  //   style: function (index) {
  //     if (!(index === 0 || index === 12)) {
  //       return 'color: black;'
  //     }
  //   }
  // }
  methods: {
    hasLink (index) {
      const item = this.performance[index]
      return item.hasLink === 'true' ? item.href : null
    },
    cardDisable (index) {
      return this.performance[index].hasLink !== 'true'
    },
    style (index) {
      return this.performance[index].hasLink !== 'true' ? 'color: black;' : ''
    }
  }
}
</script>
